import React, { useState } from 'react';
import { EditVideo, UploadThumbnail, UploadThumbnailBS, UploadThumbnailGA, UploadThumbnailRL } from '../../Services/allApi';
import { Icon } from '@iconify/react/dist/iconify.js';
import { toast } from 'react-toastify';

function AddThumb({ data, close ,which,setIsEdited}) {
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImage(file);
      setPreview(imageUrl);
    }
  };

  const handleAddImage = async () => {
    const formData = new FormData();
    const token = sessionStorage.getItem('access_token');
    const reqHeader = {
      "Authorization": `${token}`
    };
    formData.append('video_thumbnail', image);

    // Merging the formData with the existing data object
    // const updatedData = { ...data, video_thumbnail: formData.get('video_thumbnail') };
    // if(formData){
    //   console.log(formData?.get('video_thumbnail'));
    // }
    
    try {
      const res = await which=='ga'?UploadThumbnailGA(formData, reqHeader,data?.video_id):which=='bs'?UploadThumbnailBS(formData, reqHeader,data?.video_id):which=='rl'?UploadThumbnailRL(formData, reqHeader,data?.video_id):UploadThumbnail(formData, reqHeader,data?.video_id);
      console.log(res);
      if(res.status==200){
        console.log(res);
        toast.success("Thumbnail added successfully")
        setIsEdited(105)
      }else{
        toast.error(res?.response?.data?.message??res?.response?.data?.detail??"There was a problem adding thumbnail")
      }
      
        // You can add a success message or callback here if needed
        // setTimeout(()=>{
        //   close();
        // },1500)
      
    } catch (error) {
      console.error("Error updating thumbnail:", error);
    }
  };

  const handleRemoveImage = () => {
    setImage(null);
    setPreview(null);
  };

  return (
    <div className='flex flex-col justify-center items-center '>
                <div className='flex justify-end items-start w-full pb-1'><div onClick={close} className='flex justify-center items-center h-10 w-10 border-l border-b border-red-500 hover:bg-red-500 hover:text-white transform duration-500 ease-in-out cursor-pointer text-red-500'><Icon icon="iconamoon:close" className='text-2xl' /></div></div>

      <div className='flex justify-center mb-4'>
        <h5 className='text-blue-500'>Add / Update Thumbnail</h5>
      </div>

      <label htmlFor="uploadNew" className='mb-5'>
        <div className='border border-dashed border-blue-500 flex flex-col justify-center items-center cursor-pointer p-5 w-full max-w-md'>
          {preview ? (
            <img src={preview} alt="Thumbnail Preview" className='w-full h-full object-contain' />
          ) : (
            <span className='text-center text-blue-500'>
              Click here to upload new thumbnail
            </span>
          )}
        </div>
      </label>
      <input
        type="file"
        id='uploadNew'
        style={{ visibility: 'hidden' }}
        onChange={handleImageChange}
      />

      {preview && (
        <div className='flex flex-row justify-center mb-5'>
          <button
            onClick={handleAddImage}
            className='px-10 py-2 bg-green-600 text-white rounded me-2'
            disabled={!image}
          >
            Submit
          </button>
          {/* <button
            className='px-4 py-2 bg-gray-600 text-white rounded-full ms-2'
            onClick={close}
          >
            Cancel
          </button> */}
        </div>
      )}
    </div>
  );
}

export default AddThumb;
